export enum RestaurantDetailSectionId {
    DEALS = 'deals',
    REWARDS = 'rewards',
    MENU = 'menu',
    REVIEWS = 'reviews',
    INFO = 'info',
}

// Exactly the height of the 50px sticky tab bar, on mobile including the
// fixed 64px site navigation above it (matches the chip bar's sticky tops)
export const getRestaurantDetailScrollOffset = () =>
    typeof window !== 'undefined' && window.innerWidth < 768 ? 114 : 50
